import { Flex, FloatButton, Layout, Menu, MenuProps, Modal } from "antd";
import { Content, Footer, Header } from "antd/es/layout/layout";
import { useContext, useState } from "react";
import { Outlet } from "react-router";
import { CurrentUserContext } from "../Context";
import { PlusOutlined, UserOutlined } from "@ant-design/icons";
import { AuthForm } from "./AuthForm";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export function Outline() {
  const { currentUser, reloadUser, logoutUser } = useContext(CurrentUserContext)
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const { t } = useTranslation();

  const userPill = () => {
    let items: any[] = []
    if (!currentUser || currentUser.isGuest) {
      items = [
        {
          label: t("Log in"),
          icon: <UserOutlined />,
          key: "login",
          onClick: () => setModalOpen(true)
        }
      ]
    } else {
      items = [
        {
          label: currentUser.username,
          icon: <UserOutlined />,
          key: "main",
          children: [
            {
              label: (<Link to={"/user/me"}>{t("Profile")}</Link>),
              key: "profile",
            }
            ,
            {
              label: t("Logout"),
              key: "logout",
              onClick: logoutUser
            }
          ]
        }
      ]
    }
    return <Menu items={items} mode="horizontal" theme="dark" selectable={false} disabledOverflow={true} />
  }

  type MenuItem = Required<MenuProps>['items'][number];

  const mainMenuItems: MenuItem[] = []
  if (currentUser && !currentUser.isGuest) {
    mainMenuItems.push({
      label: <Link to={"/events"}>{t("Events")}</Link>,
      key: "events",
    })
  }
  return (
    <Layout>
      <Header
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 1,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Flex gap={"middle"} style={{ width: "100%" }}>
          <Menu
            theme="dark"
            mode="horizontal"
            items={mainMenuItems}
            style={{ flex: 1, minWidth: 0 }}
          />
          {userPill()}
        </Flex>
      </Header>
      <Content style={{ padding: 24, textAlign: "center" }}>
        <Outlet />
        {currentUser && !currentUser.isGuest ? <AddButton /> : undefined}
      </Content>
      <Footer><a href="https://boardgamegeek.com"><img alt="" style={{height: 20}} src="/bgg.svg"/></a></Footer>
      <Modal open={modalOpen} footer={null} onCancel={() => { setModalOpen(false) }} destroyOnClose={true}>
        <AuthForm onLogin={() => {
          reloadUser()
          setModalOpen(false)
        }} />
      </Modal>
    </Layout>
  )
}

function AddButton() {
  return <Link to={"/event/_/edit"}>
    <FloatButton icon={<PlusOutlined />} type="primary" />
  </Link>
}
